import { FormControl, TextField } from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector,useDispatch } from "react-redux";
import { ParentScreenCtx } from "../../../pages/workbench_build/WorkbenchBuild";
import { cloneDeep, debounce } from "lodash";
import { eachDeep } from "deepdash-es/standalone";
import { treeActions } from "../../../redux/slices/treeSlice";

function EDIRecordProperties() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx)
  const { rightTree } = useSelector((state) => state.treeData[parentScreen])
  const currentTab = rightTree.currentTab;
  const { translatedData,selectedNode } = rightTree.tree[currentTab]
  const [positionNumber, setPositionNumber] = useState("");
  const [loopId, setLoopId] = useState("");
  const [segmentId, setSegmentId] = useState("");
  
  const submitChange = (key, value) => {
    const updatedData = eachDeep(cloneDeep(translatedData), (obj) => {
      if (obj?.key !== selectedNode.key) return;
      obj[key] = value;
      dispatch(
        treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: obj,
        })
      );
    });
    dispatch(
      treeActions.setRightTreeTransData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );
  };
  const handlePositionNumberChange = (e) => {
    const { value } = e.target
    setPositionNumber(value);
    debounceChangeHandler('POSITION_NUMBER',value)
  };
  const handleSegmentIdChange = (e) => {
    const { value } = e.target
    setSegmentId(value);
    debounceChangeHandler('SEGMENT_ID',value)
  };
  const handleLoopIdChange = (e) => {
    const { value } = e.target
    setLoopId(value);
    debounceChangeHandler('LOOP_ID',value)
  };
  const debounceChangeHandler = useCallback(debounce(submitChange,200),[
    rightTree.currentTab,
    rightTree.tree,
    translatedData
  ])
  
  useEffect(() => {
    return () => {
      debounceChangeHandler.cancel();
    };
  }, [debounceChangeHandler]);
  
  useEffect(() => {
    setPositionNumber(selectedNode.POSITION_NUMBER || "");
    setSegmentId(selectedNode.SEGMENT_ID || "");
    setLoopId(selectedNode.LOOP_ID || "");
  }, [selectedNode?.key]);

  return (
    <>
      <FormControl variant="outlined" className="width-100" size="small">
        <TextField
          size="small"
          label={t("POSITION_NUMBER")}
          value={positionNumber}
          onChange={handlePositionNumberChange}
        />
      </FormControl>
      <FormControl variant="outlined" className="width-100" size="small">
        <TextField
          size="small"
          label={t("SEGMENT_ID")}
          value={segmentId}
          onChange={handleSegmentIdChange}
        />
      </FormControl>
      <FormControl variant="outlined" className="width-100" size="small">
        <TextField
          size="small"
          label={t("LOOP_ID")}
          value={loopId}
          onChange={handleLoopIdChange}
        />
      </FormControl>
    </>
  );
}

export default EDIRecordProperties;
